import React, { useCallback, useState } from 'react'
import PropTypes from 'prop-types'
import Modal from '../shared/Modal'

const ExportQuestionnaireModal = ({ pdfUrl, xlsxUrl }) => {
  const [isOpen, setIsOpen] = useState(false)

  const handleOpen = useCallback(() => setIsOpen(true), [])
  const handleClose = useCallback(() => setIsOpen(false), [])

  const handlePdfExport = useCallback(() => {
    window.open(pdfUrl, '_blank', 'noopener,noreferrer')
    setIsOpen(false)
  }, [pdfUrl])

  const handleXlsxExport = useCallback(() => {
    window.open(xlsxUrl, '_blank', 'noopener,noreferrer')
    setIsOpen(false)
  }, [xlsxUrl])

  const handlePdfKeyDown = useCallback(event => {
    if (event.key === 'Enter')
      handlePdfExport()
  }, [handlePdfExport])

  const handleXlsxKeyDown = useCallback(event => {
    if (event.key === 'Enter')
      handleXlsxExport()
  }, [handleXlsxExport])

  const modalTitle = (
    <>
      <i className="fas fa-download" />
      <span className="ml-2">Exporter le questionnaire</span>
    </>
  )

  return (
    <>
      <button
        className="btn btn-link p-0 ml-2"
        data-toggle="tooltip"
        title="Exporter le questionnaire"
        type="button"
        onClick={handleOpen}
      >
        <i className="fas fa-file-download" />
      </button>
      <Modal isOpen={isOpen} title={modalTitle} onClose={handleClose}>
        <div
          className="card mb-3"
          role="button"
          tabIndex={0}
          onClick={handlePdfExport}
          onKeyDown={handlePdfKeyDown}
        >
          <div className="card-body">
            <div className="d-flex align-items-start">
              <div>
                <span>
                  <i className="far fa-file-pdf fa-lg mr-1 mt-1" />
                  <strong>PDF</strong>
                </span>
                <p className="text-muted mb-0">
                  Exporter le questionnaire au format PDF.
                </p>
              </div>
            </div>
          </div>
        </div>
        <div
          className="card"
          role="button"
          tabIndex={0}
          onClick={handleXlsxExport}
          onKeyDown={handleXlsxKeyDown}
        >
          <div className="card-body">
            <div className="d-flex align-items-start">
              <div>
                <span>
                  <i className="far fa-file-excel fa-lg mr-1 mt-1" />
                  <strong>Excel</strong>
                </span>
                <p className="text-muted mb-0">
                  Exporter le questionnaire au format Excel (.xlsx).
                </p>
                <div className="alert-file-warning p-2 mt-2">
                  <small>
                    <i className="fas fa-exclamation-triangle mr-1" />
                    <span>
                      Les questions de type image, variable et PDF ne seront pas
                      exportées.
                    </span>
                  </small>
                </div>
              </div>
            </div>
          </div>
        </div>
      </Modal>
    </>
  )
}

ExportQuestionnaireModal.propTypes = {
  pdfUrl: PropTypes.string.isRequired,
  xlsxUrl: PropTypes.string.isRequired
}

export default ExportQuestionnaireModal
